import { useMutation } from "@shared/lib/hooks";
import { OrganisationService } from "../services/organisation.service";
import { ICreateOrganisationRequest } from "../types";

export function useCreateOrganisation() {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
    error: createOrganisationError,
  } = useMutation<ICreateOrganisationRequest>({
    mutationFn: (organisation: ICreateOrganisationRequest) =>
      OrganisationService.createOrganisation(organisation),
    options: {
      skipInvalidation: false,
    },
  });

  return {
    create,
    isCreating,
    isCreated,
    createOrganisationError,
  };
}
